import assertString from './util/assertString';
export default function toInt(str, radix) {
    assertString(str);
    return parseInt(str, radix || 10);
}
//# sourceMappingURL=toInt.js.map